import * as Sentry from '@sentry/react';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const initSentry = () => {
  if (!SENTRY_DSN) return;
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,
    beforeBreadcrumb(breadcrumb) {
      // Drop noisy info-level console breadcrumbs; keep warnings and errors
      if (breadcrumb.category === 'console' && breadcrumb.level === 'info') return null;
      return breadcrumb;
    },
  });
};

export const setSentryUser = (email: string, name: string, company: string) => {
  if (!SENTRY_DSN) return;
  Sentry.setUser({ email, username: name, company });
};

export const clearSentryUser = () => {
  if (!SENTRY_DSN) return;
  Sentry.setUser(null);
};

export const captureError = (error: unknown, context?: Record<string, unknown>) => {
  if (!SENTRY_DSN) return;
  Sentry.withScope(scope => {
    if (context) scope.setExtras(context);
    Sentry.captureException(error);
  });
};

export { Sentry };
